/* eslint-disable */




export function processFlightsResult(flightData) {
  try {

    let trips = []

    flightData.forEach(trip => {
      if (trip.error) {
        trips.push({
          passengers: [],
          flights: [],
          recordLocators: trip.locator ? [trip.locator] : [],
          hasError: true
        });
        return;
      }

      const itinerary = {
        passengers: [],
        flights: [],
        recordLocators: []
      }
      itinerary.passengers = trip.names
      itinerary.flights = trip.flights
      itinerary.recordLocators = trip.supplierConfirmation

      trips.push(itinerary)
    })

    return trips

  } catch (e) {
    return null
  }
}
